import { createContext, useContext, useEffect } from 'react'

import { Project } from 'api/types'

/** Shares the active project (set by ProjectLayout) with the shell above it, for the sidebar/topbar. */
export const ActiveProjectContext = createContext<{
  project: Project | null
  setProject: (project: Project | null) => void
}>({
  project: null,
  setProject: () => undefined,
})

export const useActiveProject = () => useContext(ActiveProjectContext).project

export const useSetActiveProject = (project: Project | null) => {
  const { setProject } = useContext(ActiveProjectContext)
  useEffect(() => {
    setProject(project)
    return () => setProject(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project?.id, project?.name, project?.tenderNumber, project?.startDate, project?.endDate, project?.myRole])
}
